module.exports = {
	"header": "Welcome to 1stdibs",
	"subheader": "The Most Beautiful Things on Earth from the World's Top Dealers - Now for Sale Online.",
	"cta": "how it works",
	"background": "/static/images/introduction/brand-intro-banner.jpg",
	"modal": {
		"header": "How it Works",
		"subheader": "On 1stdibs, you can purchase the one-of-a-kind pieces you love as soon as you find them.",
		"background": "/static/images/introduction/brand-intro-bg.jpg",
		"highlights": [
			{
				"icon": "storefront",
				"title": "Shop 2,500+ Hand-picked Dealers",
				"text": "We carefully select rare pieces from the world's most prestigious dealers and galleries. New listings are added weekly."
			},
			{
				"icon": "message",
				"title": "Easily Communicate With Dealers",
				"text": "By message or phone, getting questions answered and negotiating is simple."
			},
			{
				"icon": "cart",
				"title": "Purchase Online Securely",
				"text": "We offer multiple payment options, global shipping and our buyer protection guarantee to ensure that your order goes smoothly."
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/Introduction/introduction-copy.json
// module id = 2019
// module chunks = 23